import path from 'path';
import { title } from 'process';

import FindInPageIcon from '@material-ui/icons/FindInPage';
import TodayIcon from '@material-ui/icons/Today';
import Affiliations from 'components/Icons/Affiliations';
import Partenaire from 'components/Icons/Partenaire';
import Team from 'components/Icons/Team';
import { ROUTES_PATH } from 'config/constants';
import { FormattedDate, FormattedTime, useIntl } from 'react-intl';

const notificationData = (intl, type, attributes, account, date) => {
  const formattedDate = date
    ? intl.formatDate(date, {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      })
    : '';

  switch (type) {
    case 'JOIN_TEAM_INVITE':
      return {
        title: 'Invitation à rejoindre une équipe !',
        content: `envoyée par ${attributes?.organization} pour ${attributes?.team_name}`,
        description: `Le *${formattedDate}* \n\n${attributes?.organization} vous a invité(e) à rejoindre une équipe en tant que *${attributes?.team_name}* en contrat *${attributes?.contract_type}.`,
        path: ROUTES_PATH.STUDENT_DASHBOARD,
        icon: <Team />,
      };
    case 'I_INTEGRATE_TEAM':
      return {
        title: 'Intégration dans une équipe (Confirmation) !',
        content: `${attributes?.team_name} de ${attributes?.organization}`,
        description: `Le *${formattedDate}* \n\n Vous avez rejoint l’équipe de *${attributes?.team_name}* de *${attributes?.organization}* en contrat *${attributes?.contract_type}*.`,
        path: ROUTES_PATH.STUDENT_DASHBOARD,
        icon: <Team />,
      };
    case 'I_QUIT_TEAM':
      return {
        title: 'Départ de votre entreprise',
        content: `${attributes?.organization}`,
        description: `Le *${formattedDate}* \n\n Vous avez quitté l’équipe de *${attributes?.organization}*.
        \n Vous êtes de nouveau éligible pour recevoir une affiliation d’une nouvelle entreprise.
        \n Si cela est une erreur, veuillez contacter l’entreprise.`,
        path: ROUTES_PATH.STUDENT_DASHBOARD,
        icon: <Team />,
      };
    case 'JOIN_CLASSROOM_INVITE':
      return {
        title: 'Invitation à rejoindre une classe !',
        content: `envoyée par ${attributes?.organization} pour ${attributes?.classroom_name}`,
        description: `Le *${formattedDate}* \n\n*${attributes?.organization}* vous a invité(e) à rejoindre une classe en formation *${attributes?.training}* à *${attributes?.city}*.`,
        path: ROUTES_PATH.STUDENT_DASHBOARD,
        icon: <Team />,
      };
    case 'I_INTEGRATE_CLASSROOM':
      return {
        title: 'Intégration dans une classe !',
        content: `par ${attributes?.organization} pour ${attributes?.classroom_name}`,
        description: `Le *${formattedDate}* \n\n Vous avez rejoint la classe de *${attributes?.classroom_name}* de *${attributes?.organization}* en formation *${attributes?.training}* à *${attributes?.city}*.`,
        path: ROUTES_PATH.STUDENT_DASHBOARD,
        icon: <Team />,
      };
    case 'I_QUIT_CLASSROOM':
      return {
        title: 'Départ de votre école (Confirmation) !',
        content: `${attributes?.organization}`,
        description: `Le *${formattedDate}* \n\n Vous avez quitté la classe de *${attributes?.organization}*.
        \n Vous êtes de nouveau éligible pour recevoir une affiliation d’une nouvelle entreprise.
        \n Si cela est une erreur, veuillez contacter l’école.`,
        path: ROUTES_PATH.STUDENT_DASHBOARD,
        icon: <Team />,
      };
    case 'NEW_SCHOOL_AFFILIATE':
      return {
        title: 'Affiliation réceptionnée',
        content: `${attributes?.student_name} pour ${attributes?.training_name}`,
        description: ``,
        path: ROUTES_PATH.SCHOOL_AFFILIATION,
        icon: <Affiliations />,
      };
    case 'NEW_BUSINESS_AFFILIATE':
      return {
        title: 'Affiliation réceptionnée',
        content: `${attributes?.student_name} pour ${attributes?.job_name}`,
        description: ``,
        path: ROUTES_PATH.BUSINESS_AFFILIATION,
        icon: <Affiliations />,
      };
    case 'STUDENT_REJECTED_CLASSROOM_INVIT':
      return {
        title: 'Refus de rejoindre une classe',
        content: `par ${attributes?.student_name} pour rejoindre la classe ${attributes?.classroom_name}`,
        description: `Le *${formattedDate}* \n\n*${attributes?.student_name}* a refusé de rejoindre votre classe *${attributes?.classroom_name} en formation *${attributes?.training_name}* à *${attributes?.city}*.
        \n Pour plus d’information, veuillez contacter l’étudiant(e).`,
        path: ROUTES_PATH.SCHOOL_CLASSES,
        icon: <Team />,
      };
    case 'STUDENT_REJECTED_TEAM_INVIT':
      return {
        title: 'Refus de rejoindre une équipe',
        content: `par ${attributes?.student_name} pour rejoindre l'équipe ${attributes?.team_name}`,
        description: `Le *${formattedDate}* \n\n*${attributes?.student_name}* a refusé de rejoindre votre équipe ${attributes?.team_name} en tant que *${attributes?.job_name}* en contrat *${attributes?.contract_type}*.`,
        path: ROUTES_PATH.BUSINESS_TEAMS,
        icon: <Team />,
      };
    // case 'TO_MODIFY':
    //   return `Contrat terminé ${attributes?.training_name} par [Nom de l'organisme] pour [Intitulé] avec [Nom de l'organisme]`;
    case 'STUDENT_REFUSED_INVIT_TEAM':
      return {
        title: 'Refus de rejoindre une équipe',
        content: `${attributes?.organization} pour ${attributes?.intutile}`,
        description: `Le *${formattedDate}* \n\nVous avez refusé de rejoindre l’équipe de *${attributes?.organization}* pour *${attributes?.intutile}*.`,
        path: ROUTES_PATH.STUDENT_DASHBOARD,
        icon: <Team />,
      };
    case 'STUDENT_REFUSED_INVIT_CLASSROOM':
      return {
        title: 'Refus de rejoindre une classe',
        content: `${attributes?.organization} pour ${attributes?.intutile}`,
        description: `Le *${formattedDate}* \n\nVous avez refusé de rejoindre la classe de *${attributes?.organization}* pour *${attributes?.intutile}*.`,
        path: ROUTES_PATH.STUDENT_DASHBOARD,
        icon: <Team />,
      };
    case 'STUDENT_ACCEPTED_CLASSROOM_INVIT':
      return {
        title: 'Intégration dans une classe !',
        content: `${attributes?.classroom_name} pour ${attributes?.organization}`,
        description: `Le *${formattedDate}* \n\nVous avez rejoint la classe de *${attributes?.classroom_name}* pour *${attributes?.organization}*.`,
        path: ROUTES_PATH.STUDENT_DASHBOARD,
        icon: <Team />,
      };
    case 'STUDENT_DELETED_ON_TEAM':
      return {
        title: 'Retiré(e) d’une équipe',
        content: `${attributes?.organization} pour ${attributes?.job_name}`,
        description: `Le *${formattedDate}* \n\nVous avez été retiré(e) de l'équipe de ${attributes?.organization}.
        \n Dès à présent, vous êtes de nouveau éligible pour recevoir une affiliation d’une nouvelle entreprise.
        \n Si vous n’êtes pas au courant de cette décision, veuillez contacter l'entreprise.`,
        path: ROUTES_PATH.STUDENT_DASHBOARD,
        icon: <Team />,
      };
    case 'STUDENT_DELETED_ON_CLASSROOM':
      return {
        title: 'Retiré(e) d’une classe',
        content: `par ${attributes?.organization} pour ${attributes?.training_name}`,
        description: `Le *${formattedDate}* \n\nVous avez été retiré(e) de la classe de ${attributes?.organization}.
        \n Dès à présent, vous êtes de nouveau éligible pour recevoir une affiliation d’une nouvelle entreprise.
        \n Si vous n’êtes pas au courant de cette décision, veuillez contacter l'entreprise.`,
        path: ROUTES_PATH.STUDENT_DASHBOARD,
        icon: <Team />,
      };
    case 'BUSINESS_REMOVE_STUDENT_ON_TEAM':
      return {
        title: 'Retiré(e) d’un(e) étudiant(e) d’une équipe (Confirmation)',
        content: `${attributes?.student_name} n'est plus dans l'équipe ${attributes?.team_name}`,
        description: `Le *${formattedDate}* \n\n*${attributes?.student_name}* a été retiré l'équipe *${attributes?.team_name}* pour *${attributes?.organization}*.`,
        path: ROUTES_PATH.BUSINESS_DASHBOARD,
        icon: <Team />,
      };
    case 'SCHOOL_REMOVE_STUDENT_ON_CLASSROOM ':
      return {
        title: 'Retrait d’un(e) étudiant(e) d’une classe (Confirmation)',
        content: `${attributes?.student_name} n'est plus dans la classe ${attributes?.classroom_name}`,
        description: `Le *${formattedDate}* \n\n*${attributes?.student_name}* a été retiré de la classe *${attributes?.classroom_name}* pour *${attributes?.organization}*.`,
        path: ROUTES_PATH.SCHOOL_DASHBOARD,
        icon: <Team />,
      };
    case 'STUDENT_ACCEPTED_TEAM_INVIT':
      return {
        title: 'Intégration dans une équipe !',
        content: `${attributes?.team_name} pour ${attributes?.organization}`,
        description: `${attributes?.team_name} pour ${attributes?.organization}`,
        path: ROUTES_PATH.STUDENT_DASHBOARD,
        icon: <Team />,
      };
    case 'ORGANISATION_REFUSED_DOCUMENT_AFFILIATE':
      return {
        title: 'Affiliation - Document(s) refusé(s)',
        content: `par ${attributes?.organization} pour ${attributes?.intitule}`,
        description: `Le *${formattedDate}* \n\n*${attributes?.organization}* a refusé(e) des documents pour la demande d’affiliation *${attributes?.intitule}* en contrat *${attributes?.contract_type}*, pour une durée de *${attributes?.contract_length}* à *${attributes?.city}*.
        \n Cliquez sur le bouton Envoyer les documents pour transmettre les documents demandés. 
        \n Pour plus d’informations, veuillez contacter l’organisme.`,
        path: ROUTES_PATH.STUDENT_DASHBOARD,
        icon: <Affiliations />,
      };
    case 'ORGANISATION_REQUEST_NEW_DOCUMENT_AFFILIATE':
      return {
        title: 'Affiliation - Document(s) demandé(s)',
        content: `${attributes?.organization} pour ${attributes?.intitule}`,
        description: `${attributes?.organization} pour ${attributes?.intitule}`,
        path: ROUTES_PATH.STUDENT_DASHBOARD,
        icon: <Affiliations />,
      };
    case 'STUDENT_ACCEPTED_SCHOOL_AFFILIATE':
      return {
        title: 'Affiliation acceptée',
        content: `par ${attributes?.student_name} pour ${attributes?.training_name}`,
        description: `Le *${formattedDate}* \n\n*${attributes?.student_name}* a accepté(e) la demande d’affiliation pour *${attributes?.training_name}* en contrat *${attributes?.contract_type}*, pour une durée de *${attributes?.contract_length}* à *${attributes?.city}*.
        \n Si vous avez demandé des documents nécessaires au recrutement, veuillez vérifier l’authenticité de ces derniers et les valider.
        \n Si les documents ne sont pas corrects, vous pouvez les décliner et les demander de nouveau.
        \n Dans le cas où vous n’êtes pas satisfait de la procédure de recrutement avec le candidat, vous pouvez annuler l’affiliation depuis l’onglet affiliation.`,
        path: ROUTES_PATH.SCHOOL_AFFILIATION,
        icon: <Affiliations />,
      };
    case 'STUDENT_ACCEPTED_BUSINESS_AFFILIATE':
      return {
        title: 'Affiliation acceptée',
        content: `par ${attributes?.student_name} pour ${attributes?.job_name}`,
        description: `Le *${formattedDate}* \n\n*${attributes?.student_name}* a accepté(e) la demande d’affiliation pour *${attributes?.job_name}* en contrat *${attributes?.contract_type}*, pour une durée de *${attributes?.contract_length}* à *${attributes?.city}*.
        \n Si vous avez demandé des documents nécessaires au recrutement, veuillez vérifier l’authenticité de ces derniers et les valider.
        \n Si les documents ne sont pas corrects, vous pouvez les décliner et les demander de nouveau.
        \n Dans le cas où vous n’êtes pas satisfait de la procédure de recrutement avec le candidat, vous pouvez annuler l’affiliation depuis l’onglet affiliation.`,
        path: ROUTES_PATH.BUSINESS_AFFILIATION,
        icon: <Affiliations />,
      };
    case 'STUDENT_REJECTED_SCHOOL_AFFILIATE':
      return {
        title: 'Affiliation déclinée',
        content: `par ${attributes?.student_name} pour ${attributes?.training_name}`,
        description: `Le *${formattedDate}* \n\n${attributes?.student_name} a décliné(e) la demande d’affiliation pour ${attributes?.training_name} en contrat ${attributes?.contract_type}, pour une durée de ${attributes?.contract_length} à ${attributes?.city}.
        \n Pour plus d’information, veuillez vous rapprocher du candidat.`,
        path: ROUTES_PATH.SCHOOL_AFFILIATION,
        icon: <Affiliations />,
      };
    case 'STUDENT_REJECTED_BUSINESS_AFFILIATE':
      return {
        title: 'Affiliation déclinée',
        content: `par ${attributes?.student_name} pour ${attributes?.job_name}`,
        description: `Le *${formattedDate}* \n\n${attributes?.student_name} a décliné(e) la demande d’affiliation pour ${attributes?.job_name} en contrat ${attributes?.contract_type}, pour une durée de ${attributes?.contract_length} à ${attributes?.city}.
        \n Pour plus d’information, veuillez vous rapprocher du candidat.`,
        path: ROUTES_PATH.BUSINESS_AFFILIATION,
        icon: <Affiliations />,
      };
    case 'AFFILIATE_ACCEPTED_STUDENT':
      return {
        title: 'Affiliation acceptée !',
        content: `par ${attributes?.organization} pour ${attributes?.intitule}`,
        description: `Le *${formattedDate}* \n\n${attributes?.organization} a accepté(e) la demande d’affiliation pour${attributes?.intitule} en contrat ${attributes?.contract_type}, pour une durée de ${attributes?.contract_length} à ${attributes?.city}.`,
        path: ROUTES_PATH.STUDENT_DASHBOARD,
        icon: <Affiliations />,
      };
    case 'AFFILIATE_REJECTED_STUDENT':
      return {
        title: 'Affiliation déclinée',
        content: `${attributes?.organization} pour ${attributes?.intitule}`,
        description: `${attributes?.student_name} a décliné(e) la demande d’affiliation pour${attributes?.job_name}.

        \n Pour plus d’information, veuillez vous rapprocher du candidat.`,
        path: ROUTES_PATH.STUDENT_DASHBOARD,
        icon: <Affiliations />,
      };
    case 'ORGANISATION_REFUSED_AFFILIATE':
      return {
        title: 'Affiliation annulée',
        content: `${attributes?.organization} pour ${attributes?.intitule}`,
        description: `${attributes?.organization} a décliné(e) la demande d’affiliation pour${attributes?.job_name}.

        \n Pour plus d’information, veuillez vous rapprocher du candidat.`,
        path: ROUTES_PATH.STUDENT_DASHBOARD,
        icon: <Affiliations />,
      };
    case 'SCHOOL_CANCELED_AFFILIATE':
      return {
        title: 'Affiliation annulée',
        content: `${attributes?.student_name} pour ${attributes?.training_name}`,
        description: `Le *${formattedDate}* \n\nVous avez annulé l’affiliation pour *${attributes?.training_name}* en contrat *${attributes?.contract_type}*, pour une durée de *${attributes?.contract_length}* à *${attributes?.city}*.`,
        path: ROUTES_PATH.SCHOOL_AFFILIATION,
        icon: <Affiliations />,
      };
    case 'BUSINESS_CANCELED_AFFILIATE':
      return {
        title: 'Affiliation annulée',
        content: `${attributes?.student_name} pour ${attributes?.job_name}`,
        description: `Le *${formattedDate}* \n\nVous avez annulé l’affiliation pour *${attributes?.job_name}* en contrat *${attributes?.contract_type}*, pour une durée de *${attributes?.contract_length}* à *${attributes?.city}*.`,
        path: ROUTES_PATH.BUSINESS_AFFILIATION,
        icon: <Affiliations />,
      };
    case 'SCHOOL_ACCEPTED_BUSINESS_PARTNERSHIP_REQUEST':
      return {
        title: 'Partenariat accepté par une école',
        content: `par ${attributes?.school_name}`,
        description: `Le *${formattedDate}* \n\n${attributes?.school_name} a accepté la demande de partenariat.
        \n Pour plus de visibilité, votre entreprise sera visible depuis la vitrine de votre partenaire et vos offres d’emplois seront référencées sur sa vitrine.
        \n Le système de partenariat vous permet de voir les étudiants présents dans les classes du partenaire, depuis l’onglet CVThèque.
        \n Il permet également de cibler plus facilement les élèves comme étant des étudiants partenaires lors des candidatures à vos offres d’emplois.`,
        path: ROUTES_PATH.BUSINESS_PARTNERS,
        icon: <Partenaire />,
      };
    case 'BUSINESS_ACCEPTED_SCHOOL_PARTNERSHIP_REQUEST':
      return {
        title: 'Partenariat accepté par une entreprise',
        content: `par ${attributes?.organization}`,
        description: `Le *${formattedDate}* \n\n*${attributes?.organization}* a accepté la demande de partenariat.
        \n Pour plus de visibilité, votre établissement de formation est visible depuis la vitrine de votre partenaire et ses offres d’emplois sont référencées sur votre vitrine.
        \n Le système de partenariat permet désormais à l’entreprises de voir les étudiants présents dans vos classes, depuis leur onglet CVThèque.
        \n Il permet également de cibler plus facilement vos élèves comme étant des étudiants partenaires lors des candidatures aux annonces d’emplois d’entreprises partenaires.`,
        path: ROUTES_PATH.SCHOOL_PARTNERS,
        icon: <Partenaire />,
      };
    case 'BUSINESS_REFUSED_SCHOOL_PARTNERSHIP_REQUEST':
      return {
        title: 'Partenariat décliné par une entreprise',
        content: `${attributes?.organization}`,
        description: `Le *${formattedDate}* \n\n*${attributes?.organization}* a refusé la demande de partenariat.
        \n Si cela est une erreur, veuillez recontacter l’entreprise afin qu’elle réitère une demande de partenariat ou accédez à l’onglet *Partenaires* pour renvoyer une demande.`,
        path: ROUTES_PATH.SCHOOL_PARTNERS,
        icon: <Partenaire />,
      };
    case 'SCHOOL_REFUSED_BUSINESS_PARTNERSHIP_REQUEST':
      return {
        title: 'Partenariat décliné par une école',
        content: `par ${attributes?.organization}`,
        description: `Le *${formattedDate}* \n\n*${attributes?.organization}* a refusé la demande de partenariat.
        \n Si cela est une erreur, veuillez recontacter l’école afin qu’elle réitère une demande de partenariat ou accédez à l’onglet *Partenaires* pour renvoyer une demande.`,
        path: ROUTES_PATH.BUSINESS_PARTNERS,
        icon: <Partenaire />,
      };
    case 'ORGANISM_RECEIVED_PARTNERSHIP':
      return {
        title: 'Demande de partenariat réceptionnée',
        content: `${attributes?.organization}`,
        description: `Le *${formattedDate}* \n\nVous avez reçu une demande de partenariat de la part de *${
          attributes?.organization
        }*
        ${
          account === 'school'
            ? `\n Pour plus de visibilité, votre établissement de formation sera visible depuis la vitrine de votre partenaire et ses offres d’emplois seront référencées sur votre vitrine.
        \n Le système de partenariat permet aux entreprises de voir les étudiants présents dans vos classes, depuis leur onglet CVThèque. 
        \n Il permet également de cibler plus facilement vos élèves comme étant des étudiants partenaires lors des candidatures aux annonces d’emplois d’entreprises partenaires.`
            : `\n Pour plus de visibilité, votre entreprise sera visible depuis la vitrine de votre partenaire et vos offres d’emplois seront référencées sur sa vitrine.
        \n Le système de partenariat vous permet de voir les étudiants présents dans les classes du partenaire, depuis l’onglet CVThèque. 
        \n Il permet également de cibler plus facilement les élèves comme étant des étudiants partenaires lors des candidatures à vos offres d’emplois.`
        }`,
        path:
          account === 'school'
            ? ROUTES_PATH.SCHOOL_PARTNERS
            : ROUTES_PATH.BUSINESS_PARTNERS,
        icon: <Partenaire />,
      }; // entreprise et école
    case 'ORGANISM_PARTNERSHIP_SENDED':
      return {
        title: 'Partenariat envoyé',
        content: `${attributes?.organization}`,
        description: `Votre demande de partenariat est envoyé à ${attributes?.organization}.`,
        path:
          account === 'school'
            ? ROUTES_PATH.SCHOOL_PARTNERS
            : ROUTES_PATH.BUSINESS_PARTNERS,
        icon: <Partenaire />,
      }; // entreprise et école
    case 'ORGANISM_ACCEPTED_PARTNERSHIP':
      return {
        title: 'Partenariat accepté',
        content: `${attributes?.organization}`,
        description: `${attributes?.organization} a accepté la demande de partenariat.

        \n Pour plus de visibilité, votre établissement de formation est visible depuis la vitrine de votre partenaire et ses offres d’emplois sont référencées sur votre vitrine.
        
        \n Le système de partenariat permet désormais à l’entreprises de voir les étudiants présents dans vos classes, depuis leur onglet CVThèque. 
        
        \n Il permet également de cibler plus facilement vos élèves comme étant des étudiants partenaires lors des candidatures aux annonces d’emplois d’entreprises partenaires.`,
        path:
          account === 'school'
            ? ROUTES_PATH.SCHOOL_PARTNERS
            : ROUTES_PATH.BUSINESS_PARTNERS,
        icon: <Partenaire />,
      };
    case 'SCHOOL_ACCEPTED_PARTNERSHIP':
      return {
        title: 'Partenariat accepté',
        content: `${attributes?.organization}`,
        description: `${attributes?.organization} a accepté la demande de partenariat.

        \n Pour plus de visibilité, votre établissement de formation est visible depuis la vitrine de votre partenaire et ses offres d’emplois sont référencées sur votre vitrine.
        
        \n Le système de partenariat permet désormais à l’entreprises de voir les étudiants présents dans vos classes, depuis leur onglet CVThèque. 
        
        \n Il permet également de cibler plus facilement vos élèves comme étant des étudiants partenaires lors des candidatures aux annonces d’emplois d’entreprises partenaires.`,
        path:
          account === 'school'
            ? ROUTES_PATH.SCHOOL_PARTNERS
            : ROUTES_PATH.BUSINESS_PARTNERS,
        icon: <Partenaire />,
      };
    case 'ORGANISATION_OPEN_MY_APPLICATION':
      return {
        title: 'Candidature consultée',
        content: `Par ${attributes?.organization} pour ${attributes?.offer_name}`,
        description: `Le *${formattedDate}* \n\n Votre candidature pour l’annonce *${
          attributes?.offer_name
        }* en contrat *${attributes?.contract_type}* pour une durée de *${
          attributes?.contract_length
        }* à *${attributes.city}* a été consultée par *${
          attributes?.organization || ''
        }*.`,
        path: ROUTES_PATH.STUDENT_CANDIDATURES,
        icon: <FindInPageIcon />,
      };
    case 'ORGANISATION_REFUSED_MY_APPLICATION':
      return {
        title: 'Candidature déclinée',
        content: `Pour ${attributes?.offer_name}`,
        description: `Le *${formattedDate}* \n\n Votre candidature pour *${
          attributes?.offer_name
        }* en contrat *${attributes?.contract_type}* à *${
          attributes.city
        }*, a été déclinée par *${attributes?.organization || ''}*.
        \n Ne lâchez pas, vous finirez pas trouver votre bonheur !`,
        path: ROUTES_PATH.STUDENT_CANDIDATURES,
        icon: <FindInPageIcon />,
      };
    case 'ORGANISATION_ACCEPTED_MY_APPLICATION':
      return {
        title: 'Candidature acceptée !',
        content: `Pour ${attributes?.offer_name}`,
        description: `Le *${formattedDate}* \n\n Votre candidature pour *${
          attributes?.offer_name
        }* en contrat *${attributes?.contract_type}* à *${
          attributes.city
        }*, a été acceptée par *${attributes?.organization || ''}*.`,
        path: ROUTES_PATH.STUDENT_CANDIDATURES,
        icon: <FindInPageIcon />,
      };
    case 'ORGANISATION_RECEIVED_NEW_APPLICATION':
      return {
        title: 'Nouvelle candidature !',
        content: `Pour ${attributes?.offer_name}`,
        description: `Le *${formattedDate}* \n\n Vous avez réceptionné(e) la candiature de *${
          attributes?.aaplicant_name
        }* pour l’annonce *${attributes?.offer_name}* en *${
          attributes.contract_type
        }*. 
        \n Accédez à la candidature en vous rendant dans l’onglet ${
          account === 'school'
            ? '*Formations & Candidats*'
            : '*Emplois & Candidats*'
        } , puis cliquez sur *Candidats*. 
          \n Pour voir le profil du candidat, cliquez sur le *bouton menu* [image:https://cdn.discordapp.com/attachments/899252533011300373/1212344335287189544/menu.png?ex=65f17ea5&is=65df09a5&hm=adbbed35fe58ad6e517b5286c7e65dc0c0efaf45a2513c837a5d5bcb09bb5d42&] à droite de sa candidature et sur *Voir la candidature*. 
          \n Si le profil ne correspond pas à votre recherche, veuillez cliquer sur le bouton *Rejeter la candidature* depuis le *bouton menu* [image:https://cdn.discordapp.com/attachments/899252533011300373/1212344335287189544/menu.png?ex=65f17ea5&is=65df09a5&hm=adbbed35fe58ad6e517b5286c7e65dc0c0efaf45a2513c837a5d5bcb09bb5d42&]. 
          \n Dans le cas contraire, cliquez sur *Accepter la candidature* puis sur *Ajouter aux affiliations*. _(Ajouter aux affiliations n’est disponible qu’avec un abonnement payant)_
          \n Cela vous permettra de demander au candidat, des documents nécessaires à son recrutement. 
          \n Par la suite, vous pourrez alors ajouter le ou la futur(e) recruté(e) dans une équipe.`,
        path:
          account === 'school'
            ? ROUTES_PATH.SCHOOL_FORMATIONS_CANDIDATS
            : ROUTES_PATH.BUSINESS_ANNONCES_CANDIDATS,
        icon: <FindInPageIcon />,
      };
    case 'BUSINESS_VALIDATED_AFFILIATE':
      return {
        title: 'Affiliation acceptée',
        content: `${attributes?.student_name} pour ${attributes?.job_name}`,
        description: `${attributes?.student_name} a accepté(e) la demande d’affiliation pour ${attributes?.job_name}.

        \n Si vous avez demandé des documents nécessaires au recrutement, veuillez vérifier l’authenticité de ces derniers et les valider.
        
        \n Si les documents ne sont pas corrects, vous pouvez les décliner et les demander de nouveau.
        
        \n Dans le cas où vous n’êtes pas satisfait de la procédure de recrutement avec le candidat, vous pouvez annuler l’affiliation depuis l’onglet affiliation.`,
        path:
          account === 'school'
            ? ROUTES_PATH.SCHOOL_AFFILIATION
            : ROUTES_PATH.BUSINESS_AFFILIATION,
        icon: <Affiliations />,
      };
    // NEww
    case 'NEW_AFFILIATE_RECEIVED':
      return {
        title: "Demande d'Affiliation en attente",
        content: `${attributes?.organization} pour ${attributes?.intitule}`,
        description: `${attributes?.organization} a reçu(e) la demande d’affiliation pour ${attributes?.intitule}`,
        path: ROUTES_PATH.STUDENT_DASHBOARD,
        icon: <Affiliations />,
      };
    case 'ORGANISATION_VALIDATED_AFFILIATE':
      return {
        title: 'Affiliation validée par le recruteur !',
        content: `${attributes?.organization} pour ${attributes?.intitule}`,
        description: `${attributes?.organization} a validé(e) l’affiliation pour ${attributes?.intitule}`,
        path: ROUTES_PATH.STUDENT_DASHBOARD,
        icon: <Affiliations />,
      };
    case 'SCHOOL_VALIDATED_AFFILIATE':
      return {
        title: 'Affiliation acceptée',
        content: `${attributes?.student_name} pour ${attributes?.training_name}`,
        description: `${attributes?.student_name} a accepté(e) la demande d’affiliation pour ${attributes?.training_libelle}.

        \n Si vous avez demandé des documents nécessaires au recrutement, veuillez vérifier l’authenticité de ces derniers et les valider.
        
        \n Si les documents ne sont pas corrects, vous pouvez les décliner et les demander de nouveau.
        
        \n Dans le cas où vous n’êtes pas satisfait de la procédure de recrutement avec le candidat, vous pouvez annuler l’affiliation depuis l’onglet affiliation.`,
        path:
          account === 'school'
            ? ROUTES_PATH.SCHOOL_AFFILIATION
            : ROUTES_PATH.BUSINESS_AFFILIATION,
        icon: <Affiliations />,
      };
    case 'SCHOOL_RECEIVED_DOCUMENTS_AFFILIATE':
      return {
        title: 'Document(s) reçu(s) dans une affiliation !',
        content: `${attributes?.student_name} pour ${attributes?.job_name}`,
        description: `${attributes?.student_name} pour ${attributes?.job_name}`,
        path:
          account === 'school'
            ? ROUTES_PATH.BUSINESS_AFFILIATION
            : ROUTES_PATH.BUSINESS_AFFILIATION,
        icon: <Affiliations />,
      };
    case 'BUSINESS_RECEIVED_DOCUMENTS_AFFILIATE':
      return {
        title: 'Document(s) reçu(s) dans une affiliation !',
        content: `${attributes?.student_name} pour ${attributes?.job_name}`,
        description: `${attributes?.student_name} pour ${attributes?.job_name}`,
        path:
          account === 'school'
            ? ROUTES_PATH.SCHOOL_AFFILIATION
            : ROUTES_PATH.BUSINESS_AFFILIATION,
        icon: <Affiliations />,
      };
    case 'PARTNER_POST_NEW_JOB':
      return {
        title: "Un partenaire a publié une offre d'emploi !",
        content: `${attributes?.organization} pour ${attributes?.job_name}`,
        description: `Le *${formattedDate}* \n\n${attributes?.organization} a publié une offre d’emploi : ${attributes?.job_name} en contrat ${attributes?.contract_type}, de niveau ${attributes?.degree_level}, pour une durée de ${attributes?.contract_length} à ${attributes?.city}.`,
        path:
          account === 'school'
            ? ROUTES_PATH.MAP_SCHOOL
            : ROUTES_PATH.MAP_BUSINESS,
        icon: <FindInPageIcon />,
      };
    case 'ORGANISM_REFUSED_PARTNERSHIP':
      return {
        title: 'Partenariat refusé !',
        content: `${attributes?.student_name} pour ${attributes?.job_name}`,
        description: `${attributes?.organization} a refusé la demande de partenariat.

        \n Si cela est une erreur, veuillez recontacter l’entreprise afin qu’elle réïtère une demande de partenariat ou accédez à l’onglet Partenaires pour renvoyer une demande.`,
        path:
          account === 'school'
            ? ROUTES_PATH.SCHOOL_PARTNERS
            : ROUTES_PATH.BUSINESS_PARTNERS,
        icon: <Partenaire />,
      };
    case 'STUDENT_RECEIVED_CLASSROOM_INVIT':
      return {
        title: 'Intégration dans une classe !',
        content: `${attributes?.student_name} pour ${attributes?.job_name}`,
        description: ``,
        path:
          account === 'school'
            ? ROUTES_PATH.SCHOOL_CLASSES
            : ROUTES_PATH.BUSINESS_TEAMS,
        icon: <Team />,
      };
    case 'STUDENT_RECEIVED_TEAM_INVIT':
      return {
        title: 'Intégration dans une équipe !',
        content: `${attributes?.student_name} pour ${attributes?.job_name}`,
        description: `${attributes?.student_name} pour ${attributes?.job_name}`,
        path:
          account === 'school'
            ? ROUTES_PATH.SCHOOL_CLASSES
            : ROUTES_PATH.BUSINESS_TEAMS,
        icon: <Team />,
      };
    case 'SCHOOL_SEND_INVIT_CLASSROOM_SUCCESS':
      return {
        title: 'Invitation dans une classe envoyée !',
        content: `${attributes?.student_name} pour ${attributes?.job_name}`,
        description: `${attributes?.student_name} pour ${attributes?.job_name}`,
        path:
          account === 'school'
            ? ROUTES_PATH.SCHOOL_CLASSES
            : ROUTES_PATH.BUSINESS_TEAMS,
        icon: <Team />,
      };
    case 'BUSINESS_SEND_INVIT_TEAM_SUCCESS':
      return {
        title: 'Invitation dans une équipe envoyée !',
        content: `${attributes?.student_name} pour ${attributes?.job_name}`,
        description: `${attributes?.student_name} pour ${attributes?.job_name}`,
        path:
          account === 'school'
            ? ROUTES_PATH.SCHOOL_CLASSES
            : ROUTES_PATH.BUSINESS_TEAMS,
        icon: <Team />,
      };
    case 'BUSINESS_POST_NEW_JOB':
      return {
        title: 'Annonce en ligne !',
        content: `${attributes?.job_name} pour ${attributes?.degree_level}`,
        description: `*${attributes?.job_name}* pour *${attributes?.degree_level}* et pour un contrat de *${attributes?.contract_type}*`,
        path:
          account === 'school'
            ? ROUTES_PATH.MAP_SCHOOL
            : ROUTES_PATH.MAP_BUSINESS,
        icon: <FindInPageIcon />,
      };
    case 'SCHOOL_POST_NEW_TRAINING':
      return {
        title: 'Formation en ligne !',
        content: `${attributes?.training_name} pour ${attributes?.training_domain}`,
        description: `${attributes?.training_name} pour ${attributes?.training_domain}`,
        path:
          account === 'school'
            ? ROUTES_PATH.MAP_SCHOOL
            : ROUTES_PATH.MAP_BUSINESS,
        icon: <FindInPageIcon />,
      };
    case 'STUDENT_INTEGRATE_MY_TEAM':
      return {
        title: 'Votre équipe s’agrandit !',
        content: `${attributes?.student_name} a rejoint l'équipe ${attributes?.team_name}`,
        description: `Le *${formattedDate}* \n\n*${attributes?.student_name}* a rejoint votre équipe *${attributes?.team_name}* en tant que *${attributes?.job_name}* en contrat *${attributes?.contract_type}*.`,
        path: ROUTES_PATH.BUSINESS_TEAMS,
        icon: <Team />,
      };
    case 'STUDENT_INTEGRATE_MY_CLASSROOM':
      return {
        title: 'Votre classe s’agrandit !',
        content: `${attributes?.student_name} pour ${attributes?.intitule}`,
        description: `Le *${formattedDate}* \n\n*${attributes?.student_name}* a rejoint votre classe *${attributes?.classroom_name}* pour *${attributes?.training_name}* à *${attributes?.city}*`,
        path: ROUTES_PATH.SCHOOL_CLASSES,
        icon: <Team />,
      };
    case 'STUDENT_QUIT_MY_TEAM':
      return {
        title: 'Un(e) étudiant(e) à quitté(e) une équipe',
        content: `${attributes?.student_name} a quitté(e) l'équipe ${attributes?.team_name}`,
        description: `Le *${formattedDate}* \n\n*${attributes?.student_name}* a quitté(e) l'équipe *${attributes?.team_name}* en tant que *${attributes?.job_name}* en contrat *${attributes?.contract_type}*.`,
        path: ROUTES_PATH.BUSINESS_TEAMS,
        icon: <Team />,
      };
    case 'STUDENT_QUIT_MY_CALSSROOM':
      return {
        title: 'Un(e) étudiant(e) à quitté(e) une classe',
        content: `${attributes?.student_name} a quitté(e) la classe ${attributes?.classroom_name}`,
        description: `Le *${formattedDate}* \n\n*${attributes?.student_name}* a quitté(e) la classe *${attributes?.classroom_name}* pour *${attributes?.training_name}* à *${attributes?.city}*`,
        path: ROUTES_PATH.SCHOOL_CLASSES,
        icon: <Team />,
      };
    case 'JOB_SOUSCRIPTION':
      return {
        title: 'Emploi disponible !',
        content: `Lié à votre souscription`,
        description: `Le *${formattedDate}* \n\nUne souscription d’offre d'emploi correspondant à votre recherche, a été déclenchée !
        \nL'emploi *${attributes?.training_name}* en contrat *${attributes?.training_type}* à *${attributes?.city}* est disponible.
        \nInformations complémentaires : 
        - *${attributes?.training_domain}*
        - *${attributes?.degree_level}*
        - *${attributes?.training_length}*`,
        path: ROUTES_PATH.STUDENT_SOUSCRIPTION,
        icon: <FindInPageIcon />,
      };
    case 'TRAINING_SOUSCRIPTION':
      return {
        title: 'Formation disponible !',
        content: `Lié à votre souscription`,
        description: `Le *${formattedDate}* \n\nUne souscription d’offre de formation correspondant à votre recherche, a été déclenchée !
        \nLa formation *${attributes?.job_name}* en contrat *${attributes?.contract_type}* à *${attributes?.city}* est disponible.
        \nInformations complémentaires : 
        - *${attributes?.job_sector}*
        - *${attributes?.degree_level}*
        - *${attributes?.contract_length}*`,
        path: ROUTES_PATH.STUDENT_SOUSCRIPTION,
        icon: <FindInPageIcon />,
      };
    case 'ALERT_BUSINESS_APPLICATION_AWAITING':
      return {
        title: 'Une ou plusieurs candidatures nécessitent votre attention',
        content: `pour ${attributes?.job_name}`,
        description: `Le *${formattedDate}* \n\nUne ou plusieurs candidatures pour l’annonce *${attributes?.job_name}* nécessitent votre attention.`,
        path: ROUTES_PATH.BUSINESS_ANNONCES_CANDIDATS,
        icon: <FindInPageIcon />,
      };
    case 'ALERT_TRAINING_APPLICATION_AWAITING':
      return {
        title: 'Une ou plusieurs candidatures nécessitent votre attention',
        content: `pour ${attributes?.training_name}`,
        description: `Le *${formattedDate}* \n\nUne ou plusieurs candidatures pour l’annonce *${attributes?.training_name}* nécessitent votre attention.`,
        path: ROUTES_PATH.SCHOOL_FORMATIONS_CANDIDATS,
        icon: <FindInPageIcon />,
      };
    case 'BUSINESS_ABORTED_SCHOOL_PARTNERSHIP_REQUEST':
      return {
        title: 'Partenariat terminé par une entreprise',
        content: `par ${attributes?.organization}`,
        description: `Le *${formattedDate}* \n\n*${attributes?.organization}* a terminé votre partenariat.
        \n Si cela est une erreur, veuillez recontacter l’entreprise afin qu’elle réitère une demande de partenariat ou accédez à l’onglet *Partenaires* pour renvoyer une demande.`,
        path: ROUTES_PATH.SCHOOL_PARTNERS,
        icon: <Partenaire />,
      };
    case 'SCHOOL_ABORTED_BUSINESS_PARTNERSHIP_REQUEST':
      return {
        title: 'Partenariat terminé par une école',
        content: `par ${attributes?.school_name}`,
        description: `Le *${formattedDate}* \n\n*${attributes?.school_name}* a terminé votre partenariat.
        \n Si cela est une erreur, veuillez recontacter l’entreprise afin qu’elle réitère une demande de partenariat ou accédez à l’onglet *Partenaires* pour renvoyer une demande.`,
        path: ROUTES_PATH.BUSINESS_PARTNERS,
        icon: <Partenaire />,
      };
    case 'ALERT_PENDING_SCHOOL_PARTNERSHIP':
      return {
        title: 'Une ou plusieurs demandes de partenariat reçues en attentes',
        content: `depuis vos parternaires`,
        description: `Le *${formattedDate}* \n\nVous avez reçu une ou plusieurs demandes de partenariat.
        \n Pour plus de visibilité, votre établissement de formation sera visible depuis la vitrine de votre partenaire et ses offres d’emplois seront référencées sur votre vitrine.
        \n Le système de partenariat permet aux entreprises de voir les étudiants présents dans vos classes, depuis leur onglet CVThèque.
        \n Il permet également de cibler plus facilement vos élèves comme étant des étudiants partenaires lors des candidatures aux annonces d’emplois d’entreprises partenaires.`,
        path: ROUTES_PATH.SCHOOL_PARTNERS,
        icon: <Partenaire />,
      };
    case 'ALERT_PENDING_BUSINESS_PARTNERSHIP':
      return {
        title: 'Une ou plusieurs demandes de partenariat reçues en attentes',
        content: `depuis vos parternaires`,
        description: `Le *${formattedDate}* \n\nVous avez reçu une ou plusieurs demandes de partenariat.
          \n Pour plus de visibilité, votre entreprise sera visible depuis la vitrine de votre partenaire et vos offres d’emplois seront référencées sur sa vitrine.
          \n Le système de partenariat vous permet de voir les étudiants présents dans les classes du partenaire, depuis l’onglet CVThèque.
          \n Il permet également de cibler plus facilement les élèves comme étant des étudiants partenaires lors des candidatures à vos offres d’emplois.`,
        path: ROUTES_PATH.BUSINESS_PARTNERS,
        icon: <Partenaire />,
      };
    case ('ALERT_INDIVIDUAL_BUSINESS_AFFILIATE',
    'ALERT_INDIVIDUAL_SCHOOL_AFFILIATE'):
      return {
        title: 'Demande d’affiliation en attente (rappel)',
        content: `envoyée par ${attributes?.organization} pour ${attributes?.job_name}`,
        description: `Le *${formattedDate}* \n\n*${attributes?.organization}* vous a envoyé(e) une demande d'affiliation pour *${attributes?.job_name}*. en contrat *${attributes?.contract_type}* pour une durée de *${attributes?.contract_length}* à *${attributes?.city}*.
          \n La demande d'affiliation permet de vous demander de joindre des documents qui seront validés ou refusés.
          \n Si cette invitation est une erreur, veuillez la décliner ou contacter directement l'organisme qui vous l'a envoyée.`,
        path: ROUTES_PATH.STUDENT_DASHBOARD,
        icon: <Affiliations />,
      };
    case 'ALERT_SCHOOL_INDIVIDUAL_AFFILIATE':
      return {
        title: 'Demande d’affiliation en attente (rappel)',
        content: `par ${attributes?.student_name} pour ${attributes?.training_name}`,
        description: `Le *${formattedDate}* \n\n*${attributes?.organization}* vous a envoyé(e) une demande d'affiliation pour *${attributes?.training_name}*. en contrat *${attributes?.contract_type}* pour une durée de *${attributes?.contract_length}* à *${attributes?.city}*.
          \n Si vous avez des documents nécessaires au recrutement, veuillez vérifier l'authenticité de ces derniers et les valider.
          \n Si les documents ne sont pas corrects, vous pouvez les décliner et les demander de nouveau.
          \n Dans le cas où vous n'êtes pas satisfait de la procédure de recrutement avec le candidat, vous pouvez annuler l'affiliation depuis l'onglet affiliation.`,
        path: ROUTES_PATH.SCHOOL_AFFILIATION,
        icon: <Affiliations />,
      };
    case 'ALERT_BUSINESS_INDIVIDUAL_AFFILIATE':
      return {
        title: 'Demande d’affiliation en attente (rappel)',
        content: `par ${attributes?.student_name} pour ${attributes?.training_name}`,
        description: `Le *${formattedDate}* \n\n*${attributes?.organization}* vous a envoyé(e) une demande d'affiliation pour *${attributes?.training_name}*. en contrat *${attributes?.contract_type}* pour une durée de *${attributes?.contract_length}* à *${attributes?.city}*.
          \n Si vous avez des documents nécessaires au recrutement, veuillez vérifier l'authenticité de ces derniers et les valider.
          \n Si les documents ne sont pas corrects, vous pouvez les décliner et les demander de nouveau.
          \n Dans le cas où vous n'êtes pas satisfait de la procédure de recrutement avec le candidat, vous pouvez annuler l'affiliation depuis l'onglet affiliation.`,
        path: ROUTES_PATH.SCHOOL_AFFILIATION,
        icon: <Affiliations />,
      };
    default:
      return null;
  }
};

export default notificationData;
